import {HandbookEditAPI, LibraryAPI, MasterOfActsAPI} from "../../api/api.js";
import {makeTree, sortArrayByID, sortArrayByName} from "../../utils/treeUtils.js";
import {numberFormatter} from "../../utils/descriptionTemplate";

const SET_START_LOADING = 'libraryReducer/SET_START_LOADING'
const SET_STOP_LOADING = 'libraryReducer/SET_STOP_LOADING'
const SET_LIBRARY_TREE = 'libraryReducer/SET_LIBRARY_TREE'
const SET_DOCUMENTS_TREE = 'libraryReducer/SET_DOCUMENTS_TREE'
const SET_REFERENCE_DESCRIPTIONS = 'libraryReducer/SET_REFERENCE_DESCRIPTIONS'
const SET_NORMATIVE_DOCUMENTS = 'libraryReducer/SET_NORMATIVE_DOCUMENTS'
const SET_NORMATIVE_ARTICLES = 'libraryReducer/SET_NORMATIVE_ARTICLES'
const SET_CURRENT_HANDBOOK = 'libraryReducer/SET_CURRENT_HANDBOOK'

const initialState = {
    loading: false,
    libraryTree: [],
    documentsTree: null,
    referenceDescriptions: [],
    normativeDocuments: [],
    normativeArticles: [],
    currentHandbook: null
}

export const libraryReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_START_LOADING:
            return {
                ...state,
                loading: true
            }

        case SET_STOP_LOADING:
            return {
                ...state,
                loading: false
            }

        case SET_LIBRARY_TREE:
            return {
                ...state,
                libraryTree: action.nodes
            }

        case SET_DOCUMENTS_TREE:
            return {
                ...state,
                documentsTree: action.nodes
            }

        case SET_REFERENCE_DESCRIPTIONS:
            return {
                ...state,
                referenceDescriptions: action.referenceDescriptions
            }

        case SET_NORMATIVE_DOCUMENTS:
            return {
                ...state,
                normativeDocuments: action.normativeDocuments
            }

        case SET_NORMATIVE_ARTICLES:
            return {
                ...state,
                normativeArticles: action.normativeArticles
            }

        case SET_CURRENT_HANDBOOK:
            return {
                ...state,
                currentHandbook: action.currentHandbook
            }

        default:
            return state
    }
}


export const startLoading = () => ({type: SET_START_LOADING})
export const stopLoading = () => ({type: SET_STOP_LOADING})
export const selectLoading = (state) => state.libraryReducer.loading

export const setLibraryTree = (nodes) => ({type: SET_LIBRARY_TREE, nodes})
export const selectLibraryTree = (state) => state.libraryReducer.libraryTree

export const setDocumentsTree = (nodes) => ({type: SET_DOCUMENTS_TREE, nodes})
export const selectDocumentsTree = (state) => state.libraryReducer.documentsTree

export const setReferenceDescriptions = (referenceDescriptions) => ({type: SET_REFERENCE_DESCRIPTIONS, referenceDescriptions})
export const selectReferenceDescriptions = (state) => state.libraryReducer.referenceDescriptions

export const setNormativeDocuments = (normativeDocuments) => ({type: SET_NORMATIVE_DOCUMENTS, normativeDocuments})
export const selectNormativeDocuments = (state) => state.libraryReducer.normativeDocuments

export const setNormativeArticles = (normativeArticles) => ({type: SET_NORMATIVE_ARTICLES, normativeArticles})
export const selectNormativeArticles = (state) => state.libraryReducer.normativeArticles

export const setCurrentHandbook = (currentHandbook) => ({type: SET_CURRENT_HANDBOOK, currentHandbook})
export const selectCurrentHandbook = (state) => state.libraryReducer.currentHandbook



export const getLibraryNodes = (projectID) => async (dispatch) => {
    dispatch(startLoading())

    try {
        const environmentStateResponse = await MasterOfActsAPI.getEnvironmentStates(null, projectID, null, null, true)
        const referenceDescriptionsResponse = await HandbookEditAPI.getReferenceDescriptions(environmentStateResponse.data[0]?.handbook)
        const handbookResponse = await MasterOfActsAPI.getHandbook(environmentStateResponse.data[0]?.handbook)

        let normativeDocuments = []

        for (const description of referenceDescriptionsResponse.data) {
            normativeDocuments.push((await MasterOfActsAPI.getNormativeDocument(description.normative_document)).data)
        }

        await dispatch(setNormativeDocuments(normativeDocuments))
        await dispatch(setCurrentHandbook(handbookResponse.data))
        await dispatch(setReferenceDescriptions(referenceDescriptionsResponse.data))

        dispatch(setLibraryTree(normativeDocuments
            .map(el => ({...el, type: 'normativeDocument'}))
            .sort(sortArrayByName())
        ))
    } catch (e) {
        dispatch(setLibraryTree([]))
    }

    dispatch(stopLoading())
}

export const getDocumentNodes = (documentID) => async (dispatch) => {
    dispatch(startLoading())

    const chaptersResponse = await LibraryAPI.getNormativeChaptersNotDeleted(documentID)
    const articlesResponse = await LibraryAPI.getNormativeArticlesNotDeleted(documentID)

    await dispatch(setNormativeArticles(articlesResponse.data))

    const chapters = chaptersResponse.data
        .map(chapter => ({...chapter, type: 'normativeChapter'}))

    const articles = articlesResponse.data
        .map(article => ({
            ...article,
            type: 'normativeArticle',
            name: <div><strong>{numberFormatter(article.number)}</strong> {article.full_text}</div>
        }))
        .sort(sortArrayByID)

    const config = [
        {
            parentPosition: 0,
            parentKey: 'normative_chapter',
            root: true,
            rootValue: null
        },
        {
            parentPosition: 0,
            parentKey: 'normative_chapter',
            root: true,
            rootValue: null
        },
    ]

    dispatch(setDocumentsTree(makeTree([chapters, articles], config)))

    dispatch(stopLoading())
}